import React from 'react';
import {
    withRouter,
} from "react-router-dom"
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import {
    Avatar,
    IconButton,
    ListItem,
    Snackbar,
    Button,
    List,
    ListItemIcon,
    ListItemSecondaryAction
} from '@material-ui/core';

import DefaultAvatarImg from '../../images/change/default_avatar.png';
import ChevronRightOutlinedIcon from '@material-ui/icons/ChevronRightOutlined';
import Apis from '../../network/Apis';
import AppData from '../../model/AppData';
import DeviceEventEmitter, { EventName } from '../../control/event';
import MySnackbarContentWrapper from '../../component/mysnackbar';
import AppUtils from '../../control/apputlis';
import MAnchor from '../view/MAnchor';
import Swiper from 'react-id-swiper';
import SubscribeItem from '../subscribe/view/SubscribeItem';
import copy from 'copy-to-clipboard';
import MStatusBar from '../view/MStatusBar';
import TIMUtils from '../../network/TIMUtils';
import MEnvelope from '../view/MEnvelope';

const ICON1 = require("../../images/icons/minIcon1.png");
const ICON2 = require("../../images/icons/minIcon2.png");
const ICON3 = require("../../images/icons/minIcon3.png");

const ICON4 = require("../../images/icons/minIcon4.png");
const ICON5 = require("../../images/icons/minIcon5.png");
const ICON6 = require("../../images/icons/minIcon6.png");
const ICON7 = require("../../images/icons/minIcon7.png");




const MENU_LIST2 = [
    {
        title: '关注联赛', icon: ICON1,
        dialog: '/subscribematch',
    },
    {
        title: '关注主播', icon: ICON3,
        dialog: '/subscribeanchor',
    },
    {
        title: '主播相关', icon: ICON2,
        dialog: '/anchor',
    },
    // {
    //     title: '我的钱包', icon: ICON7,
    //     dialog: '/wallet',
    // },
    {
        title: '我的通讯', icon: ICON4,
        dialog: '/mymsg',
    },
    {
        title: '意见反馈', icon: ICON5,
        dialog: '/feedback',
    },
    {
        title: '分享好友', icon: ICON6,
        dialog: '/share',
    },
];


class MinePage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            Username: AppData.me.Username,
            Uid: AppData.me.Uid,
            avatar: AppData.me.Pic,
            snackmessage: '',
            snackvariant: 'info',
        };

        this.params = {
            slidesPerView: 'auto',
            spaceBetween: 20,
        };
    }

    componentDidMount() {
        DeviceEventEmitter.on(EventName.USER_LOGIN_SUCCESS, this._onLoginSuccess, this);
        DeviceEventEmitter.on(EventName.EVENT_UPDATE_USERINFO, this.updateUserInfo, this);
        DeviceEventEmitter.on(EventName.EVENT_TIM_MESSAGE_RECEIVED, this.onMessageReceived, this);
        this._getShareConfig();
        AppData.checkUpdate();
        AppUtils.YMPush('MAIN', 'MinePage');
    }

    componentWillUnmount() {
        DeviceEventEmitter.off(EventName.USER_LOGIN_SUCCESS, this._onLoginSuccess, this);
        DeviceEventEmitter.off(EventName.EVENT_UPDATE_USERINFO, this.updateUserInfo, this);
        DeviceEventEmitter.off(EventName.EVENT_TIM_MESSAGE_RECEIVED, this.onMessageReceived, this);
    }

    onMessageReceived = (event) => {
        if (TIMUtils.PRIMSG.length > 0) {
            this.setState({ showPoint: true });
        }
    }

    _getShareConfig = async () => {
        if (AppData.ShareUrl.length > 0) {
            return;
        }
        let result = await Apis.encryptionConfig();
        console.log('encryptionConfig', result);
        if (result.code == 200) {
            AppData.ShareUrl = result.data.download_url;
            AppData.ShareIcon = result.data.share_icon;
            AppData.ShareTittle = result.data.share_title;
            AppData.ShareContent = result.data.share_text;
        }
    }

    _onLoginSuccess = () => {

    }

    updateUserInfo = () => {
        this.setState({ Username: AppData.me.Username, avatar: AppData.me.Pic, });
    }



    _onListItemClick = (i) => {
        const item = MENU_LIST2[i];

        let customTab = 1;
        if (AppData.ServerConfig) {
            customTab = AppData.ServerConfig.tap_show;
        }

        if (item.dialog == '/update') {
            window.location.reload()
        } else if (item.dialog == '/subscribematch') {
            if (customTab == 2) {
                AppUtils.setStorageItem(AppUtils.SUBSCRIBE_INDEX, 1);
                this.props.history.push('subscribe');
            } else {
                DeviceEventEmitter.emit(EventName.COMMENT_MAIN_ROUTER_WHERE, 3);
            }
        } else if (item.dialog == '/subscribeanchor') {
            if (customTab == 2) {
                AppUtils.setStorageItem(AppUtils.SUBSCRIBE_INDEX, 0);
                this.props.history.push('subscribe');
            } else {
                DeviceEventEmitter.emit(EventName.COMMENT_MAIN_ROUTER_WHERE, 3);
            }

        } else if (item.dialog == '/mymsg') {
            if (customTab == 1) {
                this.props.history.push('mymsg');
            } else {
                DeviceEventEmitter.emit(EventName.COMMENT_MAIN_ROUTER_WHERE, 2);
            }
        } else if (item.dialog == '/share') {
            if (copy(AppData.ShareUrl)) {
                this.setState({ snackopened: true, snackmessage: '分享链接已复制' });
            } else {
                this.setState({ snackopened: true, snackmessage: '分享链接复制失败' });
            }
        } else {
            if (item && item.dialog) {
                this.props.history.push(item.dialog);
            }
        }
    }

    _onClickMatch = (item) => {
        AppUtils.setStorageItem(AppUtils.SUBSCRIBE_INDEX, 1);
        DeviceEventEmitter.emit(EventName.COMMENT_MAIN_ROUTER_WHERE, 3);
    }

    _onSnackClosed = () => {
        this.setState({ snackopened: false, });
    }

    _onCopyClick = () => {
        this.setState({ snackopened: true, snackmessage: '已复制ID' });
    }

    _onUserClick = () => {
        if (AppData.me.isLogin()) {
            this.props.history.push('/setting')
        }
        else {
            this.props.history.push('/login')
        }
    }

    _onClicAnchor = (data) => {
        let room_id = data.room_id ? data.room_id : 0;
        let match_type = data.match_type ? data.match_type : 0;
        let match_id = data.match_id ? data.match_id : 0;
        this.props.history.push({ pathname: '/play/' + room_id + '/' + match_type + '/' + match_id, data: data });
    }


    render() {
        const { classes } = this.props;
        const { snackopened, snackvariant, snackmessage, showPoint } = this.state;
        let MenuData = MENU_LIST2;
        let starAnchorData = AppData.starAnchorData;
        let starLeagueData = AppData.starLeagueData;

        return (
            <React.Fragment>
                <MStatusBar />
                <div className={classes.root}>
                    <Grid container className={classes.infoBox}>
                        <Grid container className={classes.infoCard}>
                            <Grid container justify='flex-end'>
                                <Button onClick={() => this.props.history.push('/syssetting')} >
                                    <img className={classes.setBtn} src={require('../../images/mine/settingbtn.png')} />
                                </Button>
                            </Grid>
                            <Grid container direction='row'>
                                <Grid>
                                    <Button onClick={() => this._onUserClick()} >
                                        <Avatar className={classes.avatar} src={this.state.avatar} />
                                    </Button>
                                </Grid>
                                <Grid container direction='row' style={{ height: 35, marginLeft: 5, flex: 1, marginTop: 10 }}>
                                    <Grid style={{ width: '100%' }}>
                                        <Typography onClick={() => this._onUserClick()} style={{ fontSize: 17, color: '#0D0D0D' }}>{AppData.me.isLogin() ? this.state.Username : '点击一键登录'}</Typography>
                                    </Grid>
                                    <Grid>
                                        <Typography style={{ fontSize: 12, color: '#878787' }}>{'ID:' + (AppData.me.isLogin() ? AppData.me.Uid : AppData.me.getUid())}</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container className={classes.menuBox}>
                            <List style={{ width: '100%' }}>
                                {
                                    MenuData.map((data, n) => (
                                        <Grid key={n} container direction='column' style={{ width: '100%' }}>
                                            <ListItem key={n + ''} style={{ backgroundColor: '#FFF' }} disableRipple button onClick={() => this._onListItemClick(n)}>
                                                <ListItemIcon style={{ alignItems: 'center', justifyContent: 'center' }}>
                                                    <Grid container direction='row' alignItems="center">
                                                        <img src={data.icon} alt='' className={classes.menuIcon} style={{ width: 17, height: 17 }} />
                                                        <Typography style={{ color: '#0D0D0D', fontSize: 14, marginLeft: 15 }}>{data.title}</Typography>
                                                        {
                                                            (showPoint || TIMUtils.PRIMSG.length > 0) && data.dialog == '/mymsg' && <Grid style={{ backgroundColor: '#FC3035', marginLeft: 4, marginBottom: 8, width: 6, height: 6, borderRadius: 3 }} />
                                                        }
                                                    </Grid>
                                                </ListItemIcon>
                                                <ListItemSecondaryAction>
                                                    <IconButton onClick={() => { this._onListItemClick(n) }}>
                                                        <ChevronRightOutlinedIcon style={{ color: '#E2E2E2', fontSize: 20 }} />
                                                    </IconButton>
                                                </ListItemSecondaryAction>
                                            </ListItem>
                                            {
                                                n == 1 && starAnchorData && <Grid container direction='row'
                                                    style={{ width: '100vw', paddingTop: 8, paddingBottom: 8, paddingLeft: 8, paddingRight: 8, backgroundColor: '#FFF' }}>
                                                    <Swiper {...this.params} >
                                                        {
                                                            starAnchorData.map((item, i) => (
                                                                <Grid key={i} style={{ width: 60 }}>
                                                                    <MAnchor key={i} showsbsb={false} data={item} name={item.nickName} avatar={item.portrait} onClick={() => this._onClicAnchor(item)} />
                                                                </Grid>
                                                            ))
                                                        }
                                                    </Swiper>
                                                </Grid>
                                            }
                                            {
                                                n == 0 && starLeagueData && <Grid container direction='column' style={{ width: '100vw' }}>
                                                    <Grid container direction='row' style={{ backgroundColor: '#FFF', width: '100vw', paddingLeft: 8, paddingRight: 8 }}>
                                                        <Swiper {...this.params} >
                                                            {
                                                                starLeagueData.map((item, i) => (
                                                                    <Grid key={i} style={{ width: 78 }}>
                                                                        <SubscribeItem selected={false} mark={true} nochan={true} data={item} onClick={() => this._onClickMatch(i)} />
                                                                    </Grid>
                                                                ))
                                                            }
                                                        </Swiper>
                                                    </Grid>
                                                    <Grid style={{ height: 8, width: '100%', backgroundColor: '#FFF' }}></Grid>
                                                    <Grid style={{ height: 8, width: '100%' }}></Grid>
                                                    <Grid style={{ height: 8, width: '100%', backgroundColor: '#FFF' }}></Grid>
                                                </Grid>
                                            }

                                        </Grid>
                                    ))
                                }
                            </List>
                        </Grid>
                    </Grid>
                    {/* <Share /> */}
                    <Snackbar
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        open={snackopened}
                        onClose={() => this._onSnackClosed()}
                        autoHideDuration={2000}
                    >
                        <MySnackbarContentWrapper
                            className={classes.snackbar}
                            message={snackmessage}
                            variant={snackvariant}
                        />
                    </Snackbar>
                    {/* <MEnvelope bottom={123} /> */}
                </div>
            </React.Fragment>
        );
    }
}

export default withRouter(withStyles((theme) => (
    {
        root: {
            flexGrow: 1,
            backgroundSize: 'cover',
            width: '100vw',
            height: '100vh',
            display: "flex",
            backgroundColor: theme.palette.background.default,
            flexDirection: "column",
            alignItems: 'center',
        },
        infoBox: {
            padding: theme.spacing(0, 0, 0.5),
            backgroundSize: '100% auto',
            backgroundRepeat: 'no-repeat',
        },
        qinxiTips: {
            backgroundColor: '#f82c5a',
            fontSize: 10,
            color: '#fff',
            position: 'absolute',
            top: 10,
            left: '50%',
            marginLeft: 8,
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
            borderBottomRightRadius: 10,
            padding: theme.spacing(0, 1, 0, 1),
        },
        copyButton: {
            fontSize: 10,
            color: '#F82A5C',
            backgroundColor: '#FFDCE3',
            padding: theme.spacing(0, 0, 0, 0),
            marginLeft: 10,
            borderRadius: 5,
        },
        header: {
            width: '100%',
            height: 58,
        },
        infoCard: {
            backgroundColor: theme.palette.background.paper,
            borderRadius: 0,
            padding: theme.spacing(2, 2, 2, 2),
        },
        btnCard: {
            backgroundColor: theme.palette.background.paper,
            borderRadius: 0,
            padding: theme.spacing(2, 2, 2, 2),
        },
        tipsContainer: {
            backgroundColor: '#F8E7CC',
            borderRadius: 10,
            color: '#BF9A60',
            marginLeft: 12,
            marginRight: 12,
            height: 35,
        },
        avatar: {
            width: 60,
            height: 60,
            color: '#fff',
            backgroundSize: 'cover',
            backgroundImage: `url(${DefaultAvatarImg})`,
        },
        setBtn: {
            width: 18,
            height: 20,
        },
        signBtn: {
            background: theme.palette.secondary.main,
            borderRadius: 17,
            color: 'white',
            height: 34,
            width: 120,
            fontSize: 14,
            fontWeight: theme.typography.fontWeightBold,
        },
        registerBtn: {
            width: 45,
            height: 45,
        },
        menuBox: {
            width: '100%',
            height: 'auto',
            // marginTop: 8,
            // backgroundColor: theme.palette.background.paper,
        },
        menuIcon: {
            color: theme.palette.secondary,
            margin: theme.spacing(0.5),
        },
        snackbar: {
            marginTop: '45vh',
        },
    }
))(MinePage));